import React from "react";
import { useSelector } from "react-redux";
import Support from "../../../../shared/components/features/support/Support";
import UserProfile from "../../../../shared/components/features/userProfile/UserProfile";
import Icon from "../../../../shared/components/ui/icons/Icon";
import iconsList from "../../../../shared/components/ui/icons/iconsList";
import logo from "../../../../assests/logo.png";
import classes from "./HeaderMobile.module.css";

const HeaderMobile = () => {

    const { texts, lang } = useSelector(state => state.translate);
    const { userDetails } = useSelector(state => state.auth);
    const accessibilityLink = useSelector(state => state?.uiData?.general?.accessibilityLink);

    return (
        <header className={classes.HeaderMobile}>
            <div className={classes.HeaderContent}>
                <div className={classes.Texts}>
                    <img src={logo} alt="" className={classes.Logo} />
                    <div className={classes.TitleBlock}>
                        <p className={classes.Title}>{texts.virtualSchool}</p>
                        <p className={classes.SchoolName}>{userDetails?.defaultSchool?.name}</p>
                    </div>
                </div>
                <div className={classes.Content}>
                    <Support />
                    <Icon
                        name={iconsList.accessibility}
                        size="26px"
                        className={classes.LinkIcon}
                        color={"#979797"}
                        onClick={() => window.open(accessibilityLink?.[lang], "_blank", "noopener,noreferrer")}
                    />
                    <div className={classes.UserProfile}>
                        <UserProfile />
                    </div>
                </div>
            </div>
        </header>
    );
};

export default HeaderMobile;